import styled from "@emotion/styled";

const Apartment = styled.label`
  font-size: 15px;
  font-weight: 400;
`;

export { Apartment };
